<template>
  <v-dialog
    max-width="1100px"
    transition="dialog-top-transition"
    v-model="isOpen"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on"
        @click.stop.prevent="isOpen = true"
        style="cursor: pointer"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-icon size="20" class="mr-2">mdi-attachment</v-icon>
              <span class="primary--text">{{ allDocumentsList.length }}</span>
            </div>
          </template>
          <span>{{ $t("agenda.lblMeetingDocumentList") }}</span>
        </v-tooltip>
      </div>
    </template>
    <template>
      <v-card>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1">
            <span
              style="
                font-size: 16px;
                font-family: Noto Sans JP !important;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              {{ title }}
            </span>
            <v-spacer></v-spacer>
            <CloseIcon @click="closeDialog()" />
          </v-toolbar>
        </v-banner>

        <v-card-text>
          <a-data-table
            v-model="selectedFiles"
            :headers="headers"
            :items="allDocumentsList"
            dense
            flat
            fixed-header
            :items-per-page="-1"
            hide-default-footer
            mobile-breakpoint="0"
            :no-data-text="$t('noData')"
            show-select
            item-key="documentId"
            height="300"
            sort-by="_ts"
            :sort-desc="true"
            :must-sort="true"
            :custom-sort="customSorting"
          >
            <template v-slot:[`header.fileName`]="{ header }">
              <span class="header-text"> {{ header.text }}</span>
            </template>
            <template v-slot:[`header.topicName`]="{ header }">
              <span class="header-text"> {{ header.text }} </span>
            </template>
            <template v-slot:[`header.size`]="{ header }">
              <span class="header-text"> {{ header.text }} </span>
            </template>
            <template v-slot:[`header.lastModified`]="{ header }">
              <span class="header-text"> {{ header.text }} </span>
            </template>
            <template v-slot:[`header._ts`]="{ header }">
              <span class="header-text"> {{ header.text }} </span>
            </template>

            <template v-slot:[`item.fileName`]="{ item }">
              <v-icon v-if="!item.extension">{{
                getFileIcon(item.fileName)
              }}</v-icon>
              <v-icon v-else>
                {{ fileIcons[item.extension] || "mdi-file" }}
              </v-icon>
              <a id="fileId" @click="onFileDownload(item)">{{
                item.fileName
              }}</a>
            </template>

            <template v-slot:[`item.size`]="{ item }">
              {{ item.size ? formatBytes(item.size) : "-" }}
            </template>
            <template v-slot:[`item.lastModified`]="{ item }">
              {{
                item.lastModified
                  ? getTimeDocumentDateTime(item.lastModified)
                  : "-"
              }}
            </template>
            <template v-slot:[`item._ts`]="{ item }">
              {{
                item._ts
                  ? getUploadedDateTime(item._ts)
                  : "-"
              }}
            </template>
            <template v-slot:[`item.topicName`]="{ item }">
              <span class="overflow-wrap">{{ item.topicName || "-" }}</span>
            </template>
          </a-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                color="secondary"
                @click="closeDialog()"
                >{{ $t("btnClose") }}</a-btn
              >
            </template>
            <span>{{ $t("btnClose") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class="ml-2"
                v-bind="attrs"
                v-on="on"
                :disabled="!selectedFiles.length"
                color="primaryDark2"
                @click="onOpenAllDocuments()"
                >{{ $t("agenda.btnOpen") }}</a-btn
              >
            </template>
            <span>{{ $t("agenda.btnOpen") }}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import {
  formatBytes,
  convertIntlDateFormat,
  openDocument,
  getTimeDocumentDateTime,
} from "../../utils/util";
import { fileIcons } from "../../utils/constant";
import ADialog from "../../wrapper-component/ADialog.vue";
import ABtn from "../../wrapper-component/ABtn.vue";
import ADataTable from "../../wrapper-component/ADataTable.vue";
export default {
  name: "AgendaDocumentList",
  components: {
    ADialog,
    ABtn,
    ADataTable,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    documents: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    hasTopic: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      selectedFiles: [],
      fileIcons,
      getTimeDocumentDateTime,
      getUploadedDateTime(millisec) {
        const date = new Date(millisec * 1000);
        let formattedDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().replace('T', ' ').substring(0, 19);
        return this.getTimeDocumentDateTime(formattedDate);
      }
    };
  },
  watch: {
    isOpen(value) {
      if (value) {
        setTimeout(() => {
          this.scrollToTop();
        }, 0);
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },

    selectedLang() {
      return this.$i18n.locale;
    },
    headers() {
      const fields = [
        {
          text: this.$t("documents.name"),
          align: "left",
          value: "fileName",
          width: 300,
          visible: true,
        },
        {
          text: this.$t("documents.hBelongTo"),
          align: "left",
          value: "topicName",
          width: 140,
          visible: this.hasTopic,
        },
        {
          text: this.$t("documents.size"),
          align: "left",
          value: "size",
          width: 100,
          visible: true,
        },
        {
          text: this.$t("search.modifiedDate"),
          align: "left",
          value: "lastModified",
          width: 230,
          visible: true,
        },
        {
          text: this.$t("agenda.lblUploadedTime"),
          align: "left",
          value: "_ts",
          width: 200,
          visible: true,
        },
      ];
      return fields.filter((f) => f.visible === true);
    },
    allDocumentsList() {
      return this.documents;
    },
  },
  methods: {
    ...mapActions({
      downloadDocumentAPI: "document/downloadDocument",
    }),
    customSorting(items, sortBy, sortDesc) {
      if (sortBy[0] === '_ts' && Boolean(sortDesc) || sortBy[0] === 'lastModified' && Boolean(sortDesc) || sortBy[0] === 'size' && Boolean(sortDesc)) {
        return _.orderBy(items, [sortBy[0]], [sortDesc[0] ? "desc" : "asc"]);
      }
      if (sortBy[0] === "fileName" || sortBy[0] === "topicName") {
        return _.orderBy(
          items,
          [item => {
            const tokens = item[sortBy[0]].split(/(\d+)/).filter(Boolean);
            return tokens.map(token => {
              if (!isNaN(token)) {
                return parseInt(token, 10);
              }
              return token.toLowerCase();
            });
          }],
          [sortDesc[0] ? "desc" : "asc", "asc"]
        );
      }
      return items;
    },
    close() {
      this.$emit("input", false);
    },
    closeDialog() {
      this.isOpen = false;
      this.selectedFiles = [];
    },
    scrollToTop() {
      document.getElementById("fileId").scrollIntoView({
        behavior: "instant",
        block: "center",
        inline: "nearest",
      });
    },
    onFileDownload,
    onOpenAllDocuments,
    formatBytes,
    convertIntlDateFormat,
    getFileIcon,
  },
};
function getFileIcon(filename) {
  let strArr = filename.split(".");
  let arrlength = strArr.length;
  if (arrlength > 0) {
    return this.fileIcons[strArr[arrlength - 1].toLowerCase()] || "mdi-file";
  }

  return "mdi-file";
}

async function onFileDownload(file) {
  const params = {
    documentId: file.documentId,
    filename: file.fileName,
  };
  const res = await this.downloadDocumentAPI(params);
  var contentType = res.headers["content-type"];
  var blob = new Blob([res.data], { type: contentType });
  var url = window.URL.createObjectURL(blob);
  openDocument(url, file.fileName);
}

function onOpenAllDocuments() {
  this.selectedFiles.forEach(async (file) => {
    const params = {
      documentId: file.documentId,
      filename: file.fileName,
    };
    const res = await this.downloadDocumentAPI(params);
    var contentType = res.headers["content-type"];
    var blob = new Blob([res.data], { type: contentType });
    var url = window.URL.createObjectURL(blob);
    openDocument(url, file.fileName);
  });
}
</script>